import m from 'mithril';
import { Store } from '../store';

export const ToastContainer: m.Component = {
    view() {
        const { toasts } = Store.state;
        
        return m('div', { class: 'fixed bottom-6 end-6 z-[9999] flex flex-col gap-3 pointer-events-none' },
            toasts.map(toast => {
                const colors = {
                    success: 'bg-green-500 text-white shadow-[0_4px_12px_rgba(34,197,94,0.4)]',
                    error: 'bg-red-500 text-white shadow-[0_4px_12px_rgba(239,68,68,0.4)]',
                    info: 'bg-[var(--color-primary)] text-white shadow-[0_4px_12px_var(--color-primary-glow)]'
                };
                const icon = {
                    success: 'lucide:check-circle',
                    error: 'lucide:alert-circle',
                    info: 'lucide:info'
                };
                return m('div', { 
                    key: toast.id,
                    class: `pointer-events-auto flex items-center gap-3 px-5 py-3.5 rounded-xl shadow-lg animate-fade-in-up transition-all ${colors[toast.type]}`
                }, [
                    m('iconify-icon', { icon: icon[toast.type], class: 'text-xl shrink-0' }),
                    m('span', { class: 'font-bold text-sm tracking-wide' }, toast.message)
                ]);
            })
        );
    }
};
